<template>
  <div class="admin-by-employee">
    <ErrorDisplay/>
    <h2 class="page-title mb-1 text-center">
      View By Employee - Today
    </h2>
    <div class="btn-toolbar justify-content-end mb-xs">
      <b-button-group>
        <router-link :to="{ name: 'AdminPage'}" tag="span">
            <b-button variant="gray" class="active"
            v-b-tooltip.bottom
                    v-b-tooltip.html
                    title="<p class='tooltip-txt'>Block View of Important Systems</p>" 
            >
            <i class="fa fa-th-large" />
            </b-button>
        </router-link>
        <b-button variant="gray" v-b-tooltip.bottom
                v-b-tooltip.html
                title="<p class='tooltip-txt'>Vertical Column View of Systems by Employees</p>
              " >
          <i class="fa fa fa-columns" />
        </b-button>
      </b-button-group>
    </div>

    <b-row v-if="allMyTasksDueToday">
        <!-- First Employee  -->
      <b-col lg="4" xs = "12" v-for="emp in employeesToShow" :key="emp">
        <h3>{{getEmployeeName(emp)}}</h3>
        <Widget>
          <b-row v-if="todaysTasksForEmployee(emp).length === 0">
            <span class="ml-4">No tasks due today! Click <router-link to="/app/todo">here</router-link> to create a task</span>
          </b-row>
          <todo-item
            v-for="(item, index) in todaysTasksForEmployee(emp)"
            :key="item.key"
            :item="item"
            :moreThanOneItems="todaysTasksForEmployee(emp).length > 1"
            :isLoading="employeeTasksLoadingStatus[index]"
            @edit="editTaskItem($event, index, 'employeetasks')"
          />
       </Widget>
       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Overdue Recall</span></h5>
            </b-col>            
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                  <span class="thumb-xs mr mt-n-sm"> 
                    <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                    <span class="glyphicon glyphicon-user"></span>
                  </span>
                  <p class="fw-semi-bold mb-xs pull-right responsible-person-badge" v-if="overdueRecallResponsible" v-b-tooltip.hover :title="overdueRecallResponsible.all.join(', ')">
                    {{ overdueRecallResponsible.first }}<span v-if="overdueRecallResponsible.count > 1" class="responsible-count">&nbsp;+{{ overdueRecallResponsible.count - 1 }}</span>
                  </p>
              </div>
            </b-col>
          </b-row>          
          <AdminTable :data="overdueRecallDataToday(emp)" :columns="overdueRecallColumns" :options="options" :extra="getExtraParams('overdue-recall')" />         
       </Widget>

       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Unscheduled Treatment</span></h5>
            </b-col>
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                  <span class="thumb-xs mr mt-n-sm"> 
                    <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                    <span class="glyphicon glyphicon-user"></span>
                  </span>
                  <p class="fw-semi-bold mb-xs pull-right responsible-person-badge" v-if="unscheduledTreatmentResponsible" v-b-tooltip.hover :title="unscheduledTreatmentResponsible.all.join(', ')">
                    {{ unscheduledTreatmentResponsible.first }}<span v-if="unscheduledTreatmentResponsible.count > 1" class="responsible-count">&nbsp;+{{ unscheduledTreatmentResponsible.count - 1 }}</span>
                  </p>
              </div>
            </b-col>
          </b-row>          
          <AdminTable v-if="unscheduledTreatmentDataToday" :data="unscheduledTreatmentDataToday(emp)" :columns="unscheduledTreatmentColumns" :options="options" :extra="getExtraParams('unscheduled-treatment')" />
       </Widget>   

       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Broken Appointments</span></h5>
            </b-col>
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                <span class="thumb-xs mr mt-n-sm"> 
                  <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                  <span class="glyphicon glyphicon-user"></span>
                </span>
                  <p class="fw-semi-bold mb-xs pull-right mb-4 responsible-person-badge" v-if="brokenAppointmentResponsible" v-b-tooltip.hover :title="brokenAppointmentResponsible.all.join(', ')">
                    {{ brokenAppointmentResponsible.first }}<span v-if="brokenAppointmentResponsible.count > 1" class="responsible-count">&nbsp;+{{ brokenAppointmentResponsible.count - 1 }}</span>
                  </p>
              </div>
            </b-col>
          </b-row>
          <AdminTable :data="brokenAppointmentsDataToday(emp)" :columns="brokenAppointmentsColumns" :options="options" :extra="getExtraParams('broken-appointments')"/>         
       </Widget>

       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Outstanding Claims</span></h5>
            </b-col>
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                  <span class="thumb-xs mr mt-n-sm"> 
                    <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                    <span class="glyphicon glyphicon-user"></span>
                  </span>
                  <p class="fw-semi-bold mb-xs pull-right mb-4 responsible-person-badge" v-if="outstandingClaimResponsible" v-b-tooltip.hover :title="outstandingClaimResponsible.all.join(', ')">
                    {{ outstandingClaimResponsible.first }}<span v-if="outstandingClaimResponsible.count > 1" class="responsible-count">&nbsp;+{{ outstandingClaimResponsible.count - 1 }}</span>
                  </p>
              </div>
            </b-col>
          </b-row>
          <AdminTable :data="outstandingClaimsDataToday(emp)" :columns="outstandingClaimsColumns" :options="options" :extra="getExtraParams('outstanding-claims')" />         
       </Widget>

       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Patient Balances</span></h5>
            </b-col>
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                <span class="thumb-xs mr mt-n-sm"> 
                  <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                  <span class="glyphicon glyphicon-user"></span>
                </span>
                <p class="fw-semi-bold mb-xs pull-right mb-4 responsible-person-badge" v-if="patientBalancesResponsible" v-b-tooltip.hover :title="patientBalancesResponsible.all.join(', ')">
                  {{ patientBalancesResponsible.first }}<span v-if="patientBalancesResponsible.count > 1" class="responsible-count">&nbsp;+{{ patientBalancesResponsible.count - 1 }}</span>
                </p>
              </div>
            </b-col>
          </b-row>
          <AdminTable :data="patientBalancesDataToday(emp)" :columns="patientBalancesColumns" :options="options" :extra="getExtraParams('patient-balances')" />         
       </Widget>

       <Widget>
          <b-row>
            <b-col xs="7">
              <h5><span class='fw-semi-bold'>Outstanding Pre-Auths</span></h5>
            </b-col>
            <b-col xs="5">
              <div class="post-user mt-n-sm">
                <span class="thumb-xs mr mt-n-sm"> 
                  <!--<img class="rounded-circle" src='../../assets/people/a4.jpg' alt="..." />-->
                  <span class="glyphicon glyphicon-user"></span>
                </span>
                <p class="fw-semi-bold mb-xs pull-right mb-4 responsible-person-badge" v-if="outstandingPreAuthsResponsible" v-b-tooltip.hover :title="outstandingPreAuthsResponsible.all.join(', ')">
                  {{ outstandingPreAuthsResponsible.first }}<span v-if="outstandingPreAuthsResponsible.count > 1" class="responsible-count">&nbsp;+{{ outstandingPreAuthsResponsible.count - 1 }}</span>
                </p>
              </div>
            </b-col>
          </b-row>
          <AdminTable :data="outstandingPreAuthDataToday(emp)" :columns="outstandingPreAuthColumns" :options="options" :extra="getExtraParams('outstanding-preauth')" /> 
       </Widget>
      </b-col>
      <!-- End of First employee -->
    </b-row>

  </div>
</template>

<script>
/* eslint-disable */
  import Vue from 'vue';
  import Widget from '@/components/Widget/Widget';
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
  import mixin from '../../mixin.js';  
  import AdminTable from './AdminTable';
  import moment from 'moment-timezone';
  import _ from 'lodash';
  import TodoItem from '../TaskList/components/TodoItem';
  import TodoDetails from '../TaskList/components/TodoDetails';
  import { getResponsibleEmployees } from '@/utils/permissions';

  export default {
    name: 'AdminByEmployeePage',
    components: { Widget, ErrorDisplay, AdminTable, TodoItem },
    mixins: [mixin],

    mounted() {
      //this.mountSlick()
      this.fetchToDos();
    },

    created() {
      this.init();
    },

    data() {
      return { 
        results: [],
        selectedPatients: [],
        options: {
          filterable: [],
          skin:'table',
          sortable: [],
          perPage: 5,
          sortByColumn: false,
          pagination: { chunk: 5, dropdown: false },
          rowClassCallback: function(row) {
            return row.teamioActive ? 'selectedRow' : '';
          }
          //columnsClasses: {id:'w'}
        },
        employeeTasksLoadingStatus: [].repeat(false, 30),
        wikiPages: [],
        mytasksColumns: ['id', 'taskContent'],
        overdueRecallColumns: ['id', 'Patient',  'FollowUpActionPlan', 'Attempts'],
        unscheduledTreatmentColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        brokenAppointmentsColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        receivedPreAuthColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        outstandingClaimsColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        outstandingPreAuthColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        patientBalancesColumns: ['id', 'Patient', 'FollowUpActionPlan', 'Attempts'],
        postOpFollowUpsColumns: ['id', 'Patient', 'Amount', 'FollowUpActionPlan', 'Attempts'],
        preMedRemindersColumns: ['id', 'Patient', 'Amount', 'FollowUpActionPlan', 'Attempts'],
        routinesColumns: []
      }
    },

    methods: {
      ...mapActions('teamio', ['runQuery']),
      ...mapActions('wiki', ['getWikiPages', 'getSiteTags']),
      ...mapActions('tasks', ['getTasksForEmployee', 'getTasksForSite', 'getTaskDetails', 'addPersonalTask', 'updateTask', 'updateMultipleTasks', 'deleteTask']),
      ...mapMutations('teamio', ['emptyResults']),

      // Shared helper for all responsible-person computed properties. Returns
      // a rich {first, all, count} object via getResponsibleEmployees so the
      // template can render "first name + N more" with a tooltip listing all
      // responsible employees. Returns null when settings/employees aren't
      // hydrated yet or no IDs in the PropertyValue resolve.
      _responsibleEmployeesFor(settingKey) {
        if (!this.allSettings || !this.allSettings[settingKey]) return null;
        return getResponsibleEmployees(this.employees, this.allSettings[settingKey].PropertyValue);
      },

      async init() {
        let query = {
          type: 'ADMIN_DASHBOARD',
          siteID: this.siteID,
          d: moment().format('YYYY-MM-DD')
        };

        this.emptyResults();
        this.results = await this.runQuery(query);
        let temp = await this.getWikiPages({siteID: this.siteID});
        if(temp.length > 0)
          this.wikiPages = temp[0];
      },

      async fetchToDos () {
        if(this.myCreatedTasks.length === 0 || this.assignedToMeTasks.length === 0 || this.myEmployeesTasks.length === 0) {
          if(this.user.Role === 'Super Admin' || this.user.Role === 'Admin')
            await this.getTasksForSite({siteID: this.siteID, employeeID: this.userID});
          else
            await this.getTasksForEmployee({siteID: this.siteID, employeeID: this.userID});
        }
      },

      async editTaskItem(item, index, taskType) {
        //console.log(`in editTaskItem, item: ${item}, index: ${index}, taskType: ${taskType}`);
        let temp;
        switch(taskType) {
          case 'allMyTasksDueToday'     : temp = this.allMyTasksLoadingStatus; break;
          case 'employeetasks'  : temp = this.employeeTasksLoadingStatus; break;
        }

        Vue.set(temp, index, true);
        let task;
        try {
          task = await this.getTaskDetails({taskID: item.id});
          //console.log(`task details: ${JSON.stringify(task)}`);
          //console.log(`got task details`);
          const panel1Handle = this.$showPanel({
            component : TodoDetails,
            openOn: 'right',
            width: 550,
            props: {
              task: task,
              wikiPages: this.wikiPages,
              patients: this.patients,
            }
          })

          panel1Handle.promise
            .then(result => {
              //console.log(`panel handle promise done`);
              Vue.set(temp, index, false);
          });
        } catch(error) {
          console.log(`Error while trying to edit task: ${error}`);
          Vue.set(temp, index, true);
        }
      },

      overdueRecallDataToday(employeeID) {
        if(this.adminData) {
           let temp = this.adminData[0].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.OverdueRecallStatusUpdatedAt).isSame(moment(), 'day') ||  t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
             /* The reason for the check below is because when the data comes from DB, it's string and then i convert to boolean locally. 
             So if I need to check the value again, I need to first check if it's boolean or not */
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }
      },

      unscheduledTreatmentDataToday(employeeID) {
        if(this.adminData && this.adminData[1].length > 0) {
           let temp = this.adminData[1].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.UnscheduledTreatmentStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }
      },

      brokenAppointmentsDataToday(employeeID) {        
        if(this.adminData && this.adminData[2].length > 0) {
          //console.log(`brokenAppointmentsDataToday called with data length ${this.adminData[2].length}: ${JSON.stringify(this.adminData[2], null, 2)}`);
           let temp = this.adminData[2].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.BrokenAppointmentStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }
      },

      outstandingClaimsDataToday(employeeID) {
        if(this.adminData && this.adminData[3].length > 0) {
           let temp = this.adminData[3].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.OutstandingClaimStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        } 
      },

      receivedPreAuthDataToday(employeeID) {
        if(this.adminData && this.adminData[4].length > 0) {
           let temp = this.adminData[4].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.ProcessedPreAuthStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }
      },
      
      outstandingPreAuthDataToday(employeeID) {
        if(this.adminData && this.adminData[5].length > 0) {
           let temp = this.adminData[5].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.OutstandingPreAuthStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }  
      },

      patientBalancesDataToday(employeeID) {
        if(this.adminData && this.adminData[6].length > 0) {
           let temp = this.adminData[6].filter(t => t.AssignedToEmpID === employeeID && (moment(t.CreatedAt).isSame(moment(), 'day') || moment(t.PatientBalancesStatusUpdatedAt).isSame(moment(), 'day') || t.dueToday === 'true' || t.pastDue === 'true'));
           temp.forEach(function(item) {
              if(typeof item['completed'] !== "boolean")
                item['completed'] = item['completed'] === 'false' ? false : true;   
           });   
           return temp;
        }
      },


    },

    computed: {

      ...mapState({
         patients: state => state.customer.patients,
         myCreatedTasks: state => state.tasks.myCreatedTasks,
         assignedToMeTasks: state => state.tasks.assignedToMeTasks,
         myEmployeesTasks: state => state.tasks.myEmployeesTasks
      }),

      ...mapGetters({
        'allMyTasksDueToday' : 'tasks/allMyTasksDueToday',
        'todaysTasksForEmployee': 'tasks/todaysTasksForEmployee'
      }), 

      adminData() {
        if(this.results && this.results.data && this.results.data.length > 0)
          return this.results.data;
      },

      employeesToShow() {
          if(this.adminData) {
              let all = [...this.adminData[0], ...this.adminData[1], ...this.adminData[2], ...this.adminData[3], ...this.adminData[4], ...this.adminData[5], ...this.adminData[6]];
              return _.map(_.uniqBy(all, 'AssignedToEmpID'), 'AssignedToEmpID');
          }
      },

      // Each *_RESPONSIBLE_EMPLOYEEID setting holds a pipe-delimited list of
      // EmployeeIDs ("empA|empB|empC"). The old code compared the entire
      // string with `===` against an individual EmployeeID, which only
      // matched for single-employee sites and silently went blank for the
      // multi-employee setups that are now standard. Each computed now
      // returns {first, all, count} so the template can render
      // "first name + N more" with a tooltip listing every responsible
      // employee. See cypress/node-tests/responsible-employees-resolution
      // for the resolution semantics.
      overdueRecallResponsible() {
        return this._responsibleEmployeesFor('OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID');
      },

      unscheduledTreatmentResponsible() {
        return this._responsibleEmployeesFor('UNSCHEDULED_TREATMENT_RESPONSIBLE_EMPLOYEEID');
      },

      brokenAppointmentResponsible() {
        return this._responsibleEmployeesFor('BROKEN_APPOINTMENTS_RESPONSIBLE_EMPLOYEEID');
      },

      outstandingClaimResponsible() {
        return this._responsibleEmployeesFor('OUTSTANDING_CLAIM_RESPONSIBLE_EMPLOYEEID');
      },

      patientBalancesResponsible() {
        return this._responsibleEmployeesFor('PATIENT_BALANCES_RESPONSIBLE_EMPLOYEEID');
      },

      // Note: previous code looked at `PROCESSED_PREAUTHS_EMPLOYEEID` /
      // `OUTSTANDING_PREAUTHS_EMPLOYEEID` (missing the `RESPONSIBLE_` prefix),
      // so these computed properties were ALWAYS undefined. Now using the
      // correct setting keys.
      processedPreAuthsResponsible() {
        return this._responsibleEmployeesFor('PROCESSED_PREAUTHS_RESPONSIBLE_EMPLOYEEID');
      },

      outstandingPreAuthsResponsible() {
        return this._responsibleEmployeesFor('OUTSTANDING_PREAUTHS_RESPONSIBLE_EMPLOYEEID');
      },

    }

  };
</script>
<!--
<style src="./TaskPage.scss" lang="scss" />
-->
<style src="./Basic.scss" lang="scss" />
<style lang="scss">
/* Compact task list layout specifically for Admin By Employee view */
.admin-by-employee {
  .TodoItem {
   /* Compact 6-column layout: checkbox | content | status | due | tag | assignee
     Use fluid columns with clamp/minmax so layout adapts to varying screen widths. */
   display: grid;
   grid-template-columns:
    22px                                 /* checkbox */
    minmax(0, 1fr)                       /* content flexes */
    clamp(56px, 7vw, 82px)               /* status */
    clamp(70px, 8vw, 110px)              /* due date */
    clamp(80px, 14vw, 150px)             /* tag */
    clamp(40px, 5vw, 56px);              /* assignee */
    column-gap: 8px;
    width: 100%;
    max-width: 100%;
    padding: 0.35rem 0.35rem !important;
    border-bottom: 1px solid #f0f2f5;
    align-items: center;
  }

  /* Hide unused columns to prevent overflow */
  .BaseTodoItem__col--attachments,
  .BaseTodoItem__col--comments,
  .BaseTodoItem__col--patients,
  .BaseTodoItem__col--repeats,
  .BaseTodoItem__col--creator,
  .BaseTodoItem__col--actions { /* actions not needed in snapshot view */
    display: none !important;
  }

  /* Place visible columns in desired order regardless of DOM order */
  /* Let auto-placement follow DOM order for remaining visible cols; just tweak alignment */
  .BaseTodoItem__col--checkbox { justify-content:center; }
  .BaseTodoItem__col--content { overflow:hidden; }
  .BaseTodoItem__col--status { justify-content:center; }
  .BaseTodoItem__col--due-date { justify-content:flex-start; white-space:nowrap; }
  .BaseTodoItem__col--tags { justify-content:flex-start; min-width:0; }
  .BaseTodoItem__col--assignees { justify-content:flex-start; min-width:0; }

  .BaseTodoItem__col { padding: 0 2px; }

  /* Truncate long task names */
  .BaseTodoItem__col--content .todo-text { white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }

  /* Tag container: single line clamp */
  .BaseTodoItem__col--tags .tag-container { flex-wrap: nowrap; overflow:hidden; }
  .BaseTodoItem__col--tags .tag { max-width: 70px; font-size:10px; padding:2px 6px; margin-right:4px; white-space:nowrap; }
  /* Show only first tag visually, but keep others for tooltip accessibility */
  .BaseTodoItem__col--tags .tag:nth-child(n+2){ display:none; }
  .BaseTodoItem__col--tags .tag-container { position:relative; }
  .BaseTodoItem__col--tags .tag-container:hover::after {
      content: attr(data-all-tags);
      position:absolute;
      left:0; top:100%;
      background:#1f2937; color:#fff;
      padding:4px 6px; border-radius:4px;
      font-size:10px; white-space:nowrap;
      transform:translateY(4px);
      box-shadow:0 2px 6px rgba(0,0,0,0.15);
      z-index:10;
  }

  /* Assignees column shrink handling */
  .BaseTodoItem__col--assignees { min-width: 0; }
  /* Hide assignee name; show tooltip on avatar instead */
  .BaseTodoItem__col--assignees .creator-name { display:none !important; }
  .BaseTodoItem__col--assignees .assignee-count { margin-left:4px; font-size:10px; background:#eef2f6; padding:2px 6px; }
  .BaseTodoItem__col--assignees .creator-avatar { width:24px; height:24px; font-size:0.65rem; }
  /* Improve avatar legibility (initials) */
  .BaseTodoItem__col--assignees .creator-avatar { font-size:0.72rem; line-height:24px; font-weight:600; }

  /* Due date alignment */
  .BaseTodoItem__col--due-date .date-container { justify-content: flex-start; }
  .BaseTodoItem__col--due-date .badge-due-today, .BaseTodoItem__col--due-date .date-text { font-size:10px; padding:2px 6px; line-height:1; }
  .BaseTodoItem__col--status .status-badge { font-size:10px; padding:2px 6px; letter-spacing:0; line-height:1; }

  /* Responsive adjustments within each employee column */
  @media (max-width: 1200px) { /* slight squeeze */
  .TodoItem { grid-template-columns: 20px minmax(0,1fr) clamp(52px,8vw,74px) clamp(64px,9vw,96px) clamp(70px,18vw,140px) clamp(36px,6vw,50px); }
  }
  @media (max-width: 992px) { /* hide tags to preserve space */
  .TodoItem { grid-template-columns: 20px minmax(0,1fr) clamp(50px,9vw,72px) clamp(64px,10vw,90px) clamp(38px,6vw,48px); }
    .BaseTodoItem__col--tags { display:none !important; }
    .BaseTodoItem__col--assignees { grid-column: 5; }
  }
  @media (max-width: 768px) { /* collapse further: hide assignees */
  .TodoItem { grid-template-columns: 20px minmax(0,1fr) clamp(50px,10vw,70px) clamp(64px,14vw,90px); }
    .BaseTodoItem__col--assignees { display:none !important; }
  }
}

/* --- Compact AdminTable styles for admin-by-employee view (do not affect main Admin page) --- */
.admin-by-employee .overdue-recall-table { /* wrapper each mini table uses */
  /* tighten spacing between stacked widgets */
  margin-bottom: .5rem;
}

.admin-by-employee .overdue-recall-table table {
  table-layout: fixed; /* prevent column width explosion */
  width: 100%;
  border-collapse: collapse;
}

.admin-by-employee .overdue-recall-table thead th {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 6px;
  line-height: 1.2;
  white-space: nowrap;
  border-bottom: 1px solid #eef2f5 !important;
}

.admin-by-employee .overdue-recall-table tbody td {
  padding: 4px 6px !important;
  font-size: 11px;
  line-height: 1.15;
  vertical-align: middle;
  border-top: 1px solid #f4f6f8;
}

/* Column widths: checkbox | patient | follow-up action plan | attempts */
/* Use CSS vars for column sizing so they can be tuned globally if needed */
.admin-by-employee {
  --abe-col-checkbox: 32px; /* widened to prevent checkbox clipping */
  --abe-col-followup-min: 108px;
  --abe-col-followup-max: 170px;
  --abe-col-attempts-min: 54px;
  --abe-col-attempts-max: 88px;
}

.admin-by-employee .overdue-recall-table th:nth-child(1),
.admin-by-employee .overdue-recall-table td:nth-child(1) { width: var(--abe-col-checkbox); text-align:center; }

.admin-by-employee .overdue-recall-table th:nth-child(2),
.admin-by-employee .overdue-recall-table td:nth-child(2) { width: auto; }

.admin-by-employee .overdue-recall-table th:nth-child(3),
.admin-by-employee .overdue-recall-table td:nth-child(3) { width: clamp(var(--abe-col-followup-min), 32vw, var(--abe-col-followup-max)); }

.admin-by-employee .overdue-recall-table th:nth-child(4),
.admin-by-employee .overdue-recall-table td:nth-child(4) { width: clamp(var(--abe-col-attempts-min), 12vw, var(--abe-col-attempts-max)); text-align:center; }

/* Patient column: show only primary line (name + first badge) */
.admin-by-employee .overdue-recall-table td:nth-child(2) { position: relative; overflow:hidden; }
.admin-by-employee .overdue-recall-table td:nth-child(2) a { display:inline-block; max-width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
/* Hide extra paragraphs & secondary informational lines */
.admin-by-employee .overdue-recall-table td:nth-child(2) p { display:none !important; }
/* Limit to first status button/badge */
.admin-by-employee .overdue-recall-table td:nth-child(2) .btn + .btn { display:none !important; }
/* Condense badge / button styling */
.admin-by-employee .overdue-recall-table td:nth-child(2) .btn,
.admin-by-employee .overdue-recall-table td:nth-child(2) .badge { padding:2px 6px; font-size:10px; line-height:1; margin-top:2px; }

/* Follow Up Action Plan column: shrink dropdown buttons & badges */
.admin-by-employee .overdue-recall-table td:nth-child(3) { white-space:nowrap; }
.admin-by-employee .overdue-recall-table td:nth-child(3) .btn,
.admin-by-employee .overdue-recall-table td:nth-child(3) .dropdown-toggle { padding:2px 6px !important; font-size:10px; line-height:1; }
.admin-by-employee .overdue-recall-table td:nth-child(3) .b-dropdown { display:inline-block; }
/* Prevent long inner form in mini view taking width while closed */
.admin-by-employee .overdue-recall-table td:nth-child(3) .dropdown-menu { max-width:260px; }

/* Attempts column: tighter icon spacing */
.admin-by-employee .overdue-recall-table td:nth-child(4) i { font-size:14px; margin-right:2px; }
.admin-by-employee .overdue-recall-table td:nth-child(4) i:last-child { margin-right:0; }

/* Follow Up Action Plan cell: grid layout with right-side indicator stack */
.admin-by-employee .overdue-recall-table td:nth-child(3) {
  display: grid;
  grid-template-columns: 1fr 18px; /* main control | indicator column */
  grid-auto-rows: auto;
  align-items: start;
  gap: 0 6px;
  position: relative;
}
.admin-by-employee .overdue-recall-table td:nth-child(3) .b-dropdown,
.admin-by-employee .overdue-recall-table td:nth-child(3) .badge { grid-column:1; grid-row:1; }
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle { grid-column:2; grid-row:1; margin:4px 0 0 0; }
/* (Legacy grid stacking removed) Keep subsequent icons inline */
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ i,
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ .glyphicon { margin-left:4px !important; margin-top:0 !important; font-size:13px; display:inline-block; }
/* Ensure icon column doesn't stretch layout */
.admin-by-employee .overdue-recall-table td:nth-child(3) > i,
.admin-by-employee .overdue-recall-table td:nth-child(3) > .glyphicon { justify-self:center; }

/* Checkbox column: ensure visibility */
.admin-by-employee .overdue-recall-table td:nth-child(1) { overflow: visible; }
.admin-by-employee .overdue-recall-table td:nth-child(1) .abc-checkbox { margin:0; padding:0; }

/* Generic adjustments */
.admin-by-employee .overdue-recall-table .btn { border-radius:4px; }
.admin-by-employee .overdue-recall-table .glyphicon-ban-circle { font-size:14px; }

/* Hover clarity within compact cells */
.admin-by-employee .overdue-recall-table tbody tr:hover td { background:#fafbfc; }

/* Reduce pagination footprint if present inside column view */
.admin-by-employee .overdue-recall-table .VuePagination { padding:4px 0 0; }
.admin-by-employee .overdue-recall-table .VuePagination li a { padding:2px 6px; font-size:11px; }

@media (max-width: 1200px) {
  .admin-by-employee { --abe-col-followup-max: 150px; }
}
@media (max-width: 1024px) {
  .admin-by-employee { --abe-col-followup-max: 138px; --abe-col-attempts-max: 80px; }
}
@media (max-width: 900px) {
  /* When column is very narrow, hide textual badge overflow inside patient column instead of wrapping entire row */
  .admin-by-employee .overdue-recall-table td:nth-child(2) .btn { max-width: 90%; overflow:hidden; text-overflow:ellipsis; }
}
@media (max-width: 768px) {
  /* As columns stack tighter inside each employee column (e.g. on tablets in portrait), reduce padding further */
  .admin-by-employee .overdue-recall-table thead th,
  .admin-by-employee .overdue-recall-table tbody td { padding:3px 4px !important; }
  .admin-by-employee { --abe-col-followup-min: 96px; }
}
@media (max-width: 640px) {
  /* Last resort: hide Attempts icons if width becomes too constrained (user still has them in full Admin page) */
  .admin-by-employee .overdue-recall-table th:nth-child(4),
  .admin-by-employee .overdue-recall-table td:nth-child(4) { display:none; }
}

/* --- Refinement: allow more space for Follow Up column, keep icons inline --- */
/* Tighten Patient column so Follow Up Action Plan gets more horizontal room */
.admin-by-employee .overdue-recall-table th:nth-child(2),
.admin-by-employee .overdue-recall-table td:nth-child(2) {
  width: clamp(120px, 36%, 260px);
}
/* Expand Follow Up column proportionally */
.admin-by-employee .overdue-recall-table th:nth-child(3),
.admin-by-employee .overdue-recall-table td:nth-child(3) {
  width: clamp(150px, 46%, 320px);
}

/* Override earlier grid layout: use flex so icons stay on same line */
.admin-by-employee .overdue-recall-table td:nth-child(3) {
  display: flex !important;
  align-items: center;
  gap: 6px;
  padding-right: 4px !important;
  white-space: nowrap;
}
/* Main control (dropdown / badge) flexes */
.admin-by-employee .overdue-recall-table td:nth-child(3) .b-dropdown,
.admin-by-employee .overdue-recall-table td:nth-child(3) .badge {
  flex: 1 1 auto;
  min-width: 0;
}
/* Icon group: keep inline; slight spacing */
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle,
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa,
.admin-by-employee .overdue-recall-table td:nth-child(3) .glyphicon {
  margin-top: 0 !important;
}
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle { margin-left: 2px !important; }
/* Trim icon sizes for inline fit */
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ i,
.admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ .glyphicon { font-size: 13px; }

/* If space gets too tight, progressively hide lowest-priority icons after red dot */
@media (max-width: 1100px) {
  .admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ .glyphicon:last-of-type { display:none; }
}
@media (max-width: 1000px) {
  .admin-by-employee .overdue-recall-table td:nth-child(3) .fa-circle ~ .glyphicon { display:none; }
}

/* "+N more" chip after the first responsible person's name when multiple
   employees share the assignment. Hover shows the full list via v-b-tooltip. */
.responsible-person-badge .responsible-count {
  font-size: 0.75em;
  color: #94a3b8;
  font-weight: 500;
  background-color: #f1f5f9;
  padding: 1px 6px;
  border-radius: 8px;
  margin-left: 2px;
}

</style>



